module.exports = __webpack_public_path__ + "img/18.ce58bc03.jpg";